import { useEffect, useRef, useState } from "react";
import { Link } from "react-router-dom";
import Icon from "../Icon/icon";
import { IconNames } from "../Icon/types";

interface ILink {
  title: string;
  link?: string;
  onAction?: () => void;
  valueSet?: React.Dispatch<React.SetStateAction<boolean>>;
  blank?: boolean;
  iconName?: IconNames;
}

interface Props {
  children: JSX.Element;
  list: ILink[];
}

const Dropdown = ({ children, list }: Props) => {
  const [isCollapsed, setIsCollapsed] = useState<boolean>(true);
  const ref = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const handleClickOutside = (e: MouseEvent) => {
      if (ref.current && !ref.current.contains(e.target as Node)) {
        setIsCollapsed(true);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  const parseLink = (link: string) => {
    const [pathname, search] = link.split("?");
    return search ? { pathname, search: `?${search}` } : pathname;
  };

  return (
    <div
      ref={ref}
      className="dropdown"
      role="listbox"
      onMouseEnter={() => setIsCollapsed(false)}
      onMouseLeave={() => setIsCollapsed(true)}
      onClick={() => setIsCollapsed((prev) => !prev)}
    >
      {children}
      <div className={`collapsible-content${isCollapsed ? " collapsible-content--hidden" : ""}`}>
        {list.map((item, index) =>
          item.onAction ? (
            <button
              key={index}
              className="dropdown-link dropdown-link--action"
              role="option"
              onClick={(e) => {
                e.stopPropagation();
                item.onAction?.();
                setIsCollapsed(true);
              }}
            >
              {item.iconName && (
                <Icon name={item.iconName} iconWidth="1.2rem" className="icon--inherit" />
              )}
              <span>{item.title}</span>
            </button>
          ) : (
            <Link
              key={index}
              to={parseLink(item.link ?? "/")}
              className="dropdown-link"
              role="option"
              onClick={(e) => {
                e.stopPropagation();
                item.valueSet?.(true);
                setIsCollapsed(true);
              }}
              target={item.blank ? "_blank" : ""}
            >
              {item.iconName && (
                <Icon name={item.iconName} iconWidth="1.2rem" className="icon--inherit" />
              )}
              <span>{item.title}</span>
            </Link>
          ),
        )}
      </div>
    </div>
  );
};

export default Dropdown;
